import { render, staticRenderFns } from "./Layout1Flex.vue?vue&type=template&id=513d1502&"
import script from "./Layout1Flex.vue?vue&type=script&lang=js&"
export * from "./Layout1Flex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports